import React, { useState, useEffect } from "react";
import api from "../Services/api";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import icoDownload from '../../assets/img/ico-download.svg';
import "./styles.css";

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);

const Forms = (props: any) => {

	const [forms, setForms] = useState<any[]>([]);

	useEffect(() => {
		api.get(props.page).then((response) => {
			if (props.subgroup) {
				setForms(response.data.results.filter((item: any) => item.SubGrupo === props.subgroup));
			} else {
				setForms(response.data.results);
			}

		})
			.catch((err) => {
				throw new Error(err);
			});
	}, [props.page, props.subgroup]);

	return (
		<>
			<section className="_carousel-posts mb-10 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-md-10 col-lg-8  offset-md-1">

						</div>

						<div className="col-md-10 col-lg-8 offset-md-1">
							<div className="carousel-cr carousel-post-0">

								<div className="swiper-wrapper">
									<Swiper
										// effect={"coverflow"}
										grabCursor={true}

										slidesPerView={"auto"}
										// coverflowEffect={{
										// 	rotate: 100,
										// 	stretch: 50,
										// 	depth: 100,
										// 	modifier: 2,
										// 	slideShadows: false
										// }}
										pagination={false}
										style={{ maxWidth: "45%", maxHeight: "50%", right: "28%" }}
									>
										{forms.map((item: any) => (
											<SwiperSlide>
												<div className="wiper-slide">
													<div className="card-form bg-light ">
														<div ></div>
														<div className="card-form__title" style={{ maxHeight: '20%' }}>
															<h4 style={{ fontSize: "16px" }}> {item.Title} </h4>
														</div>
														<div className="card-form__desc form-desc" title={item.Descricao} style={{ position: 'relative', top: '-50px' }}>
															<p>
																{item.Descricao}
															</p>

														</div>

														<div className="card-comunicado__btn form-btn-url" style={{ position: 'fixed' }}>
															<a rel="noreferrer" href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100">
																<img src={icoDownload} alt="Ícone" />
															</a>
														</div>
													</div>

												</div>
											</SwiperSlide>
										))}
									</Swiper>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
};
export default Forms;